import { dialog, InputJson, toDisplayCase } from "../../../../../nq-component";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import withRouter from "../../../../../withRouter";
import BaseFormPage from "../../../../../base/BaseFormPage";
import NavBar from "../../../../../components/navbar";
import FormFactory from "../../../../../components/FormFactory";
import RawMaterialFormPresenter from "./RawMaterialFormPresenter";
import DialogModal from "../../../../../components/Dialog";

class RawMaterialFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { object: {}, advanced: false };
    this.presenter = new RawMaterialFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
      findObjectUseCase(),
    );
  }

  getCollectionName() {
    return "raw_materials";
  }

  onSubmitForm(e) {
    e.preventDefault();

    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Confirm to Proceed"
          message="Are you sure want to continue this action?"
          isCancelButton={true}
          onSubmit={() => this.presenter.submit()}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  render() {
    const object = this.state.object;
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add " : "Edit ";
    return (
      <>
        <NavBar />
        <div className="overflow-auto">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1
                className="fw-bold mt-3 text-capitalize"
                style={{ color: "#82c14a" }}
              >
                <i
                  onClick={() => this.navigateBack()}
                  class="bi bi-chevron-compact-left"
                  style={{ color: "black" }}
                ></i>
                {label +
                  (schema.label || toDisplayCase(this.getCollectionName()))}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <h6>Details</h6>
                <hr />
                <form onSubmit={this.onSubmitForm.bind(this)}>
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChange.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <FormFactory
                        schema={schema}
                        object={object}
                        onChange={this.onChange.bind(this)}
                      />
                    )}
                  </div>
                  <div className="mt-4 text-center">
                    <button
                      type="button"
                      className="btn btn-light fs-sm "
                      onClick={this.onClickBack.bind(this)}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn fs-sm text-white ms-3"
                      style={{ backgroundColor: "#82c14a" }}
                    >
                      <i className="bi text-white bi-file-earmark-check me-2"></i>
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(RawMaterialFormPage);
